import request from "../axios-instance";
import { uploadIxdToStagingSlot } from "../ixd-upload/policy";
import {
  IxdForwardRun,
  IxdForwardRunListResponse,
  StartIxdForwardParams,
} from "./types";

/** IXD 를 스테이징에 올린 뒤 시작 API 를 호출한다 — 응답의 runId 로 폴링한다. */
export const startIxdForward = async ({
  priorDsd,
  priorIxd,
  tableLimit,
  onIxdUploadProgress,
}: StartIxdForwardParams): Promise<IxdForwardRun> => {
  const uploadId = await uploadIxdToStagingSlot(priorIxd, (loaded, total) =>
    onIxdUploadProgress?.(total > 0 ? loaded / total : 0),
  );

  const formData = new FormData();
  formData.append("prior_dsd", priorDsd);
  formData.append("ixd_upload_id", uploadId);
  formData.append("ixd_filename", priorIxd.name);
  if (tableLimit !== undefined) {
    formData.append("table_limit", String(tableLimit));
  }
  const response = await request.post("/v1/ixd-forward/start", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const getIxdForwardRuns = async (): Promise<IxdForwardRunListResponse> => {
  const response = await request.get("/v1/ixd-forward/runs");
  return response.data;
};

export const getIxdForwardRun = async (
  runId: string,
): Promise<IxdForwardRun> => {
  const response = await request.get(`/v1/ixd-forward/runs/${runId}`);
  return response.data;
};
